module.exports = __webpack_public_path__ + "static/media/noon.0e7af6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noon.png
// module id = 964
// module chunks = 0